import { gsap } from 'gsap';

function whenImagesReady(root) {
    const images = [...root.querySelectorAll('img')];
    if (!images.length) return Promise.resolve();

    return Promise.all(
        images.map((img) =>
            img.complete
                ? Promise.resolve()
                : new Promise((resolve) => {
                      img.addEventListener('load', resolve, { once: true });
                      img.addEventListener('error', resolve, { once: true });
                  }),
        ),
    );
}

function startMarquee(track) {
    const inner = track.querySelector('.marquee__inner');
    const seed  = inner?.querySelector('.marquee__content');
    if (!inner || !seed) return;

    const duration = Math.max(5, Number(track.getAttribute('data-marquee-duration')) || 25);
    const reverse  = track.getAttribute('data-marquee-direction') === 'right';

    const minWidth = Math.max(track.offsetWidth, window.innerWidth) * 2;
    let guard = 0;
    while (inner.scrollWidth < minWidth && guard < 40) {
        inner.append(seed.cloneNode(true));
        guard += 1;
    }

    [...inner.children].forEach((child) => {
        inner.append(child.cloneNode(true));
    });

    const half = () => inner.scrollWidth / 2;
    if (half() < 1) return;

    if (reverse) {
        gsap.fromTo(inner, { x: () => -half() }, { x: 0, duration, ease: 'linear', repeat: -1 });
    } else {
        gsap.fromTo(inner, { x: 0 }, { x: () => -half(), duration, ease: 'linear', repeat: -1 });
    }
}

export function psScrollingText() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const run = () => {
        document.querySelectorAll('.ps-scrolling-text-block [data-ps-marquee]').forEach((track) => {
            whenImagesReady(track).then(() => startMarquee(track));
        });
    };

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(run).catch(run);
    } else {
        run();
    }
}
